import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ApiClient from '../utilities/apiClient';
import AppConfig from '../AppConfig';
import Ledger from './Ledger';
import { useAppData } from '../redux/appDataProvider';


const LedgerController = () => {
  const [fromDate, setFromDate] = useState(new Date().toLocaleDateString()); // Initialize with current date or another valid date
  const [toDate, setToDate] = useState(new Date().toLocaleDateString()); // Initialize with current date or another valid date
  const [datePickerValue, setDatePickerValue] = useState(null);
  const [summary, setSummary] = useState([]);
  const [ledgerData, setLedgerData] = useState({});
  const { selectedYear, setSelectedYear } = useAppData();
  const [showModal, setshowModal] = useState(false);
  const handleSubmit = () => {
    // Handle submit logic here
  };
  const handleDownload = () => {
    // Handle download logic here
  };
  const apiToken = useSelector(state => state.auth.apiToken);
  const userId = useSelector(state => state.auth.userId);


  useEffect(() => {
    // Simulate fetching data from an API or some other source
    const fetchData = async () => {
      try {
        // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMjE2NjA2OSwiZXhwIjoxNzEyMTY3ODY5fQ.bixIkQQbMg_bmwi8CecC_oRv-AyUurenbsbPHaRCTQk";
        const apiClient = new ApiClient(apiToken);
        apiClient.fetchData(
          AppConfig.api.Ledger.summary,
          "POST",
          {
            "ClientId": userId,
            "FinStart": selectedYear.Database_Year ? selectedYear.Database_Year : localStorage.getItem("year")
          })
          .then((response) => {
      
            if(response && response.Success == "True" && response.hasOwnProperty("Success Description")){
              let responseData = response["Success Description"]; 
              console.info(`data ${responseData}`);
              if (Array.isArray(responseData) && responseData.length > 0) {
                setSummary(responseData[0]);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error('Error fetching holding data:', error);
      }
    };

    fetchData();
  },  []); // Empty dependency array to fetch data only once on component mount
  
  return <Ledger 
    ledgerData={ledgerData}
    summary={summary}
    showModal={showModal}
    setDatePickerValue={setDatePickerValue}
    // handleExchangeChange={handleExchangeChange}
    handleSubmit={handleSubmit}
    handleDownload={handleDownload}
  />;



};

export default LedgerController;
